import styled from "styled-components";
import { palette } from "styled-theme";

const Wrapper = styled.div`
  .validation {
    color: ${palette("error", 3)};
  }
  .validation iframe {
    box-shadow: inset 0px 0px 0px 2px ${palette("error", 2)} !important;
    border-radius: 5px;
    padding: 10px 0;
    
  }

  #fgf-bank-frame {
    border: none;
    width: 100%;
    height: ${props => props.$iframeHeight}px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;

export default Wrapper;
